import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';
import { ArrayIncludesPipe } from '../../pipes/array-includes.pipe';

@Component({
  selector: 'app-toggle-tabs-menu',
  standalone: true,
  imports: [
    ArrayIncludesPipe
  ],
  templateUrl: './toggle-tabs-menu.component.html',
  styleUrl: './toggle-tabs-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToggleTabsMenuComponent extends BaseComponent {

  @Input({ required: true }) options: string[];
  @Input() selectedIndex = 0;
  @Input() allowDeselect = false;
  @Input() disabledIndexes: number[] = [];
  @Input() hiddenIndexes: number[] = [];

  @Output() selectedIndexChange = new EventEmitter<number>();
}
